/*!
  * @license MIT (https://github.com/geotrev/spider-ui/blob/master/LICENSE)
  * @spider-ui/global-event-registry v0.2.5 (https://github.com/geotrev/spider-ui/tree/master/packages/global-event-registry#readme)
  * Copyright 2020 George Treviranus <hello@geotrev.com>
  */
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var init = Symbol("#init");
var findReverse = Symbol("#findReverse");
var entryExists = Symbol("#entryExists");
var typesReducer = Symbol("#typesReducer");
var isValidEntry = Symbol("#isValidEntry");
var handleEvent = Symbol("#handleEvent");
var STATE_KEY = "__SPIDER_UI_GLOBAL_EVENT_REGISTRY__";
/**
 * This utility is an event bus to track
 */

var GlobalEventRegistry = /*#__PURE__*/function () {
  function GlobalEventRegistry() {
    _classCallCheck(this, GlobalEventRegistry);

    this[init]();
    this[handleEvent] = this[handleEvent].bind(this);
  } // public


  _createClass(GlobalEventRegistry, [{
    key: "register",
    value: function register() {
      var entryConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this[isValidEntry](entryConfig)) return;
      this[typesReducer]("register", entryConfig.types);
      this.entries.push(entryConfig);
    }
  }, {
    key: "unregister",
    value: function unregister(targetId) {
      var _this = this;

      if (!this.entries.length) return;
      if (typeof targetId !== "string") return;
      var activeEntry = this.entries[this.entries.length - 1];

      if (activeEntry.id === targetId) {
        var entry = this.entries.pop();
        this[typesReducer]("unregister", entry.types);
      } else {
        this[findReverse](this.entries, function (entry, index) {
          if (entry.id === targetId) {
            _this.entries.splice(index, 1);

            _this[typesReducer]("unregister", entry.types);

            return true;
          }
        });
      }
    }
  }, {
    key: init,
    // private
    value: function value() {
      if (STATE_KEY in window) return;
      var value = [];
      var types = {};
      value.types = types; // Add it to the window. This will ensure duplicates
      // never create multiple stores.

      Object.defineProperty(window, STATE_KEY, {
        value
      });
    }
  }, {
    key: findReverse,
    value: function value(array, callback) {
      if (!Array.isArray(array) || !array.length) return;

      for (var i = array.length - 1; i >= 0; i--) {
        var result = callback(array[i], i);
        if (result === true) break;
      }
    }
  }, {
    key: entryExists,
    value: function value(id) {
      var exists = false;
      this[findReverse](this.entries, function (entry) {
        if (entry.id !== id) return;
        exists = true;
        return exists;
      });
      return exists;
    }
  }, {
    key: typesReducer,
    value: function value(reducerType, eventTypes) {
      var _this2 = this;

      switch (reducerType) {
        case "register":
          {
            eventTypes.forEach(function (type) {
              var eventCount = _this2.types[type];

              if (!eventCount) {
                window.addEventListener(type, _this2[handleEvent], true);
                _this2.types[type] = 1;
              } else {
                _this2.types[type] = eventCount + 1;
              }
            });
            break;
          }

        case "unregister":
          {
            eventTypes.forEach(function (type) {
              var eventCount = _this2.types[type];

              if (eventCount === 1) {
                delete _this2.types[type];
                window.removeEventListener(type, _this2[handleEvent], true);
              } else {
                _this2.types[type] = eventCount - 1;
              }
            });
            break;
          }
      }
    }
  }, {
    key: isValidEntry,
    value: function value(entry) {
      return Object.keys(entry).length && Array.isArray(entry.types) && entry.types.length && typeof entry.handler === "function" && typeof entry.id === "string" && !this[entryExists](entry.id);
    }
  }, {
    key: handleEvent,
    value: function value(event) {
      if (!this.entries.length || !Object.keys(this.types).length) return;
      var activeEntry = this.entries[this.entries.length - 1];

      if (activeEntry.types.indexOf(event.type) > -1) {
        activeEntry.handler(event);
      }
    }
  }, {
    key: "entries",
    get: function get() {
      return window[STATE_KEY];
    }
  }, {
    key: "types",
    get: function get() {
      return window[STATE_KEY].types;
    }
  }]);

  return GlobalEventRegistry;
}();

var globalEventRegistry = new GlobalEventRegistry();

export { globalEventRegistry };
//# sourceMappingURL=global-event-registry.es.js.map
